// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:248d67eb-a08d-4853-a1da-0ee5804aeff1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_1mAYzZXJa",
    "aws_user_pools_web_client_id": "1bqrd8cupnc833s0gqd5cgmpdt",
    "oauth": {},
    "aws_user_files_s3_bucket": "adpstorage102421-pro",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
